<template>
  <div class="modal fade" id="move-plant" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header" :class="[headerColor]">
            <h3 class="block-title"><i class="fa fa-angle-double-right"></i>Move Plants</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{ errorMsg }}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Id</label>
              <input name="plantId" v-model="id" type="text" v-validate="'required'" data-vv-as="Plant ID" class="form-control form-control-alt" placeholder="Plant Id">
              <p v-if="errors.has('plantId')" class="errorMsg">{{ errors.first('plantId') }}</p>
            </div>
            <div class="form-group">
              <label>Plant Label</label>
              <input name="plantLabel" v-model="label" type="text" class="form-control form-control-alt" placeholder="Plant label">
            </div>
            <div class="form-group required">
              <label class="control-label">New Room</label>
              <select id="move-plant-room" class="form-control form-control-alt v-plant-select2-dropdown" placeholder="Select Room.." style="width: 100%">
                <option></option>
                <option :value="room.Name" v-for="(room, index) in library.rooms" :key="index">{{ room.Name }}</option>
              </select>
              <p v-if="roomError" class="errorMsg">The Room field is required.</p>
            </div>
            <div class="form-group">
              <label>Date</label>
              <input v-model="date" id="move-plant-datepicker" type="text" class="form-control form-control-alt" placeholder="Date">
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click.prevent="movePlant()" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i>Save</div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'MovePlant',
  data() {
    return {
      id: 0,
      label: '',
      newRoom: '',
      date: new Date().toJSON().slice(0,10),
      errorMsg: '',
      showModalLoader: false,
      roomError: false,
      headerColor: 'bg-info'
    };
  },
  components: {
    HashLoader
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('#move-plant-room').on('change', function() {
      vm.newRoom = $(this).val(); vm.roomError = false;
    });

    let datePicker = $('#move-plant-datepicker').datepicker(
      { format: 'yyyy-mm-dd', autoclose: true }
    );
    datePicker.on('changeDate', (e) => {
      vm.date = e.format();
    });
  },
  methods: {
    clearData() {
      this.id = '';
      this.label = '';
      this.newRoom = '';
      this.date = new Date().toJSON().slice(0,10);
      $('.v-plant-select2-dropdown').val(null).trigger('change');
      $('#move-plant-datepicker').datepicker('update', this.date);
      this.$validator.reset();
    },
    setPlantDetails(plant, bgColor) {
      this.id = plant.Id;
      this.label = plant.Label;
      this.headerColor = bgColor;
    },
    movePlant() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest(
            '/plants/moveplants',
            {
              Id: this.id,
              Label: this.label,
              Room: this.newRoom,
              ActualDate: this.date
            }
          ).then((data) => {
            if (data.status === 'success') {
              vm.showModalLoader = false;
              vm.$emit('loadPlants', true);
              jQuery('#move-plant').modal('hide');
              vm.clearData();
              helper.showSuccessModal(data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    validate() {
      if (!this.newRoom) {
        this.roomError = true;
      }

      if (this.roomError) {
        return false;
      }
      return true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/MovePlant.vue